import React from 'react';
import ButtonBase from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { string, bool, number, oneOfType } from 'prop-types';
import THEME from '../../../constants/theme';

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: ({ borderRadius }) => borderRadius || '8px',
    padding: ({ padding }) => `${padding} !important ` || '',
    height: ({ height }) => height || '40px',
    letterSpacing: 'unset',
    marginLeft: ({ ml }) => ml || '0',
    marginTop: ({ mt }) => mt || '0',
    fontSize: ({ fontSize }) => fontSize || '14px',
    width: ({ width }) => width || 'auto',
    display: ({ inlineBlock }) => inlineBlock && 'inline-block',
    alignSelf: ({ alignSelf }) => alignSelf || '',
    flex: ({ flex }) => flex || '0 1 auto',
    color: ({ color }) => color || 'inherit',
    textTransform: 'none',
  },
  endIcon: {
    marginLeft: ({ endiconmarginleft }) => endiconmarginleft || '8px',
  },
  textPrimary: {
    color: '#4E40EF',
    letterSpacing: 'unset !important',
    paddingLeft: '0',
    fontWeight: ({ fontWeight }) => fontWeight || '500',
    '&:hover': {
      color: '#3023C8',
      backgroundColor: 'rgba(255,255,255,0)',
      '& svg': {
        color: '#3023C8',
      },
    },
  },
  textSecondary: {
    color: '#787F88',
    fontWeight: 'normal',
    '&:hover': {
      color: '#4E40EF',
      backgroundColor: 'rgba(255,255,255,0)',
      '& svg': {
        color: '#4E40EF',
      },
    },
  },
  contained: {
    boxShadow: 'none',
    fontWeight: ({ fontWeight }) => fontWeight || '500',
  },
  containedPrimary: {
    color: '#fff',
    backgroundColor: THEME.primaryColors.primary,
    '&:hover': {
      color: '#fff',
      backgroundColor: THEME.primaryColors.primaryD20,
    },
    '&:disabled': {
      color: '#fff',
      backgroundColor: '#9CA0FF',
    },
  },
  containedSecondary: {
    color: `${THEME.primaryColors.black}`,
    backgroundColor: ({ backgroundColor }) => backgroundColor || '#F5F6F7',
    '&:hover': {
      backgroundColor: '#E6E9EC',
    },
    '& .MuiButton-startIcon': {
      color: '#787F88',
    },
    '&:disabled': {
      color: '#787F88',
      backgroundColor: '#F5F6F7',
    },
  },

  label: {
    textTransform: 'none !important',
    letterSpacing: 'unset',
  },
}));

const ButtonRounded = ({
  borderRadius,
  ml,
  mt,
  backgroundColor,
  hoverColor,
  hoverTextColor,
  width,
  inlineBlock,
  alignSelf,
  flex,
  ...props
}) => {
  const classes = useStyles({
    borderRadius,
    ml,
    mt,
    backgroundColor,
    hoverColor,
    hoverTextColor,
    width,
    inlineBlock,
    alignSelf,
    flex,
    ...props,
  });

  return <ButtonBase {...props} classes={classes} />;
};

ButtonRounded.propTypes = {
  borderRadius: string,
  ml: string,
  mt: string,
  backgroundColor: string,
  hoverColor: string,
  hoverTextColor: string,
  width: string,
  inlineBlock: bool,
  alignSelf: string,
  flex: oneOfType([number, string]),
};

ButtonRounded.defaultProps = {
  borderRadius: null,
  ml: null,
  mt: null,
  backgroundColor: null,
  hoverColor: null,
  hoverTextColor: null,
  width: null,
  inlineBlock: null,
  alignSelf: null,
  flex: null,
};

export { ButtonRounded };
